import { render, staticRenderFns } from "./InviteRelation.vue?vue&type=template&id=bd221518&scoped=true&"
import script from "./InviteRelation.vue?vue&type=script&lang=js&"
export * from "./InviteRelation.vue?vue&type=script&lang=js&"
import style0 from "./InviteRelation.vue?vue&type=style&index=0&id=bd221518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd221518",
  null
  
)

export default component.exports